<template>
  <div class="inp_container brains-type1-number-input" :class="{ 'brains-input--disabled' : disabled }">
    <input v-model="displayValue" :placeholder="placeholder" type="text" :disabled="disabled" @blur="isInputActive = false" @focus="isInputActive = true">
    <font-awesome-icon v-if="icon !== ''" class="svg-input" :icon="icon" />
  </div>
</template>

<script>
export default {
  name: 'TextInput',
  props: {
    value: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isInputActive: false
    }
  },
  computed: {
    displayValue: {
      get: function() {
        if (this.value === undefined || this.value === null) {
          return
        }
        if (this.isInputActive) {
          return this.value.toString()
        } else {
          // return this.value.toFixed(2).replace(/(\d)(?=(\d{3})+(?:\,\d+)?$)/g, '$1.') + ' €'
          return this.value.toLocaleString('it-IT')
        }
      },
      set: function(modifiedValue) {
        this.$emit('input', modifiedValue)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.inp_container {
  position: relative;
  display: flex;
  align-items: center;

  .svg-input {
    right: 5px;
    position: absolute;
    color: rgb(128, 128, 128);
  }
}

.inp_container,
.inp_container > input {
  width: 100%;
  height: 100%;
}

.brains-input--disabled input {
  background-color: rgb(240, 240, 240) !important;

  &:hover {
    outline-color: rgb(221, 221, 221);
  }
}
</style>
